import { SWReactIcons } from "@similarweb/icons";
import type { HTMLAttributeAnchorTarget, MouseEventHandler, ReactNode } from "react";

import { StyledTooltipLink } from "./styles";

type Props = {
    className?: string;
    target: HTMLAttributeAnchorTarget;
    href: string;
    children: ReactNode;
    withIcon?: boolean;
    onClick?: MouseEventHandler<HTMLAnchorElement>;
};

const TooltipLinkItem = (props: Props) => {
    const { className, target, href, children, withIcon = false, onClick } = props;

    return (
        <StyledTooltipLink
            className={className}
            data-automation="tooltip-more-items-link"
            target={target}
            href={href}
            onClick={onClick}
        >
            {children}
            {withIcon ? (
                <SWReactIcons
                    iconName="open-new-window"
                    size="xs"
                />
            ) : null}
        </StyledTooltipLink>
    );
};

export default TooltipLinkItem;
